export const ContactType = {
    "internal": "internal",
    "external": "external"
}